(function () {
    'use strict';

    angular
        .module('app.directive')
        .directive('taiBulletinDetail', taiBulletinDetail);

    function taiBulletinDetail() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: ControllerController,
            controllerAs: 'vm',
            link: link,
            templateUrl: 'directive/taiBulletinDetail.html',
            restrict: 'E',
            scope: {
                data: '=',
                title: '=',
                type: '@'
            }
        };
        return directive;

        function link() {}
    }
    /* @ngInject */
    function ControllerController(apiUrl, sysCode, commonService, headerService,
        $routeParams, bulletinService, $http, $scope) {
        var vm = this;
        vm.download = download;
        vm.getBackUrl = getBackUrl;
        
        // 1.8.2 父層參數 data  無法直接從 scope 引入
        // 故利用 $scope.$parent.vm 的屬性
        vm.data = $scope.$parent.vm.data;

        onInit();

        function onInit() {
            if (vm.data.attachmentSerilNo > 0) {
                vm.url = bulletinService.getStampFile(vm.data.attachmentSerilNo);
                // vm.url = apiUrl.pafUrl+vm.url
                const a = document.createElement('a');
                const el = document.body.appendChild(a);
                el.setAttribute('style', 'display: none');
                el.href = vm.url;
                el.click();
            }
        }

        function download(item) {
      
            // 先註解 看看在APP中是不是就不會發生錯誤
            
            //20180803 re-open by Anthony
            //台新反映外網下載附件沒有紀錄
            var params = {
                bulletinSerilNo: item.bulletinSerilNo,
                attachmentSerilNo: item.attachmentSerilNo
            };
            commonService.setParams(params);
            headerService.saveBulletinClickingAttachment(params);


            if (commonService.getFileType(item.attachmentUrl) !== 'pdf') {
                bulletinService.checkHeadStatus(item.attachmentUrl).then(() => {
                    location.href = item.attachmentUrl;
                });
            } else {
                bulletinService.checkHeadStatus(item.attachmentUrl).then(() => {
                    
                    //location.href = bulletinService.getStampFile(item.attachmentSerilNo);
                    //2023-07-20 Johnson 資安2023
                    eval(function(p,a,c,k,e,r){e=function(c){return c.toString(a)};if(!''.replace(/^/,String)){while(c--)r[e(c)]=k[c]||e(c);k=[function(e){return r[e]}];e=function(){return'\\w+'};c=1};while(c--)if(k[c])p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c]);return p}('$8({9:\'a\',b:c.d(2.e),f:\'g\'}).h(3 i(0){j 1=0.1();4 5=1[\'k-6\'];4 7=l m([0.n],{6:5});o(7,2.p)},3 q(0){});',27,27,'response|headers|item|function|var|contentType|type|blob|http|method|GET|url|bulletinService|getStampFile|attachmentSerilNo|responseType|arraybuffer|then|success|let|content|new|Blob|data|saveAs|attachmentName|reject'.split('|'),0,{}))

                });
            }
        }

        function getBackUrl() {
            switch (vm.type) {
                case 'bulletin':
                    return '#/bulletin/more/1?menu=32';
                case 'notice':
                    if ($routeParams.isBulletin) {
                        return '#/bulletin/more/1?menu=32';
                    }
                    return '#/tsu/bulletin/more?menu=43';
                default:
                    return '#/nextMenu?menu=' + getMenuQueryString();
            }
        }
    }
})();